"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSubEvents = exports.MetricsChannels = void 0;
var MetricsChannels;
(function (MetricsChannels) {
    MetricsChannels["NETWORK"] = "network-metrics";
    MetricsChannels["RESOLVER_CALLED"] = "resolver-called";
    MetricsChannels["RESOLVER_ERROR"] = "resolver-error";
    MetricsChannels["RESOLVER_DONE"] = "resolver-done";
    MetricsChannels["SENT_RESPONSE"] = "sent-response";
    MetricsChannels["GOT_REQUEST"] = "got-request";
    MetricsChannels["GOT_ERROR"] = "got-error";
    MetricsChannels["REQUEST_IDS"] = "request-ids";
})(MetricsChannels || (MetricsChannels = {}));
exports.MetricsChannels = MetricsChannels;
var PubSubEvents;
(function (PubSubEvents) {
    PubSubEvents["RESOLVER_CALLED"] = "resolverCalled";
    PubSubEvents["RESOLVER_DONE"] = "resolverDone";
    PubSubEvents["RESOLVER_ERROR"] = "resolverError";
})(PubSubEvents || (PubSubEvents = {}));
exports.PubSubEvents = PubSubEvents;
//# sourceMappingURL=metrics.enum.js.map